export default function PageNotFound() {
  return (
    <div className="flex flex-col items-center justify-between my-20 h-100">
      <div className="text-42 text-red-700">404</div>
      <div className="text-24">Sorry, we couldn't find this page</div>
    </div>
  );
}
